import { pipe, without, isEmpty } from "ramda";

const arrayMatch = pipe(without, isEmpty);

export default arrayMatch;
